<template>
  <v-container fluid>
    <div class="d-flex flex-column flex-md-row justify-space-between">
      <h1>{{ $t('MANAGEMENT_PAGE.TITLE.HEADER_USER') }} </h1>

    </div>
    <v-tabs v-model="tab" color="#559a1b" class="mt-8 mt-md-0">
      <v-tab
          v-if="checkPermission(['ACCOUNT_MANAGEMENT'])"
          @click="refreshData('accountList')"
          value="account">
        {{ $t('MANAGEMENT_PAGE.BUTTON.ACCOUNT') }}
      </v-tab>
    </v-tabs>

    <v-window v-model="tab">
      <v-window-item value="account">
        <AccountListPage ref="accountList"/>
      </v-window-item>
    </v-window>
  </v-container>
</template>

<script>
import AccountListPage from '@/components/management/AccountList.vue';

export default {
  name: 'ManagementPage',
  components: { AccountListPage },
  data() {
    return {
      tab: 'account',
      hoverNewAccount: false,
      prevRoute: null
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  watch: {
    prevRoute(value) {
      if (value?.path && value.path.split('/')) {
        if (value.path.split('/')[1] === 'roles') {
          this.tab = 'role'
        }
      }
    }
  },
  methods: {
    checkPermission(permissionsRequired) {
      return this.$store.getters['auth/hasPermission'](permissionsRequired)
    },
    refreshData($component) {
      if (this.$refs && this.$refs[$component]) {
        this.$refs[$component].getAccountList()
      }
    }
  }
}
</script>

<style scoped>
.v-container {
  padding: 32px;
}

:deep(.v-tab) {
  border-radius: unset;
}

:deep(.v-tab--selected .v-btn__content) {
  font-weight: bold;
}

:deep(.v-btn__content) {
  text-transform: capitalize;
}
</style>
